import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import {
  getGroupDescriptionRef,
  type GroupDescriptionRef,
} from '../dataobject/valueDate/utils';
import {
  dataObjectGroupsWithDescriptionsQueryKey,
  getDataObjectGroupsWithDescriptionsQuery,
  type DataObjectGroupWithDescriptionsQueryParams,
} from './query/useDataObjectGroupsWithDescriptionsQuery';

export const useFetchGroupDescriptionRef = () => {
  const queryClient = useQueryClient();

  return useCallback(
    async (
      descriptionId: number,
      params?: DataObjectGroupWithDescriptionsQueryParams,
    ): Promise<GroupDescriptionRef | undefined> => {
      const groups = await queryClient.fetchQuery({
        queryKey: [...dataObjectGroupsWithDescriptionsQueryKey, params],
        queryFn: () => getDataObjectGroupsWithDescriptionsQuery(params),
      });

      for (const group of groups) {
        const description = group.descriptions?.find(
          (item) => item.id === descriptionId,
        );

        if (description) {
          return getGroupDescriptionRef(
            group.id ?? description.dataObjectGroupId,
            descriptionId,
          );
        }
      }

      return undefined;
    },
    [queryClient],
  );
};
